class ComboTreeBox {
  loadComboTree(input_box_id_combotree) {
    console.log("Loaded Combobox Tree");
    if (sessionStorage["comboTree"] === "" || typeof sessionStorage["comboTree"] == "undefined") {
      $.ajax({
        url: "/get_combo_tree",
        type: "POST",
        error: function (xhr, status) {
          let error_status = xhr.status;
          if (error_status == 599) {
            new PageContents().tokenExpireAction();
          }
          console.log("Error Status:", error_status);
          return {};
          // alert(xhr.status);
        },
      }).done(function (data) {
        // console.log("AJAX to hit ",data);
        var combo_tree_status = data.status;
        if (combo_tree_status === "success") {
          sessionStorage["comboTree"] = JSON.stringify(data);

          data = JSON.parse(sessionStorage["comboTree"]);
          if (data.status === "success") {
            console.log("This is data received!!>>", data);
            var JSONTreeData = data["tree_obj"];

            jQuery(document).ready(function ($) {
              comboTree1 = $("#" + input_box_id_combotree).comboTree({
                source: JSONTreeData,
                isMultiple: true,
                collapse: true,
                cascadeSelect: true,
                cascadeCheck: false,
              });
              try {
                document.getElementsByClassName("comboTreeArrowBtn")[0].remove();
              } catch (error) {
                console.log("Error:", error);
              }
            });
          } else {
            console.log("Data not received, hence combotree not loaded");
          }
        }
      });
    }
    return comboTree1;
  }

  executeCleanupCombobox() {
    console.log("Going to change the combobox");
    document.getElementById("comboBoxTree").click();
    var random_number = document.getElementById("comboBoxTree").parentNode.getAttribute("id").replace("comboTree", "").replace("InputWrapper", "");
    var second_input_id = "comboTree" + random_number + "MultiFilter";
    document.getElementById(second_input_id).click();
    var multiples_input_id = document.getElementsByClassName("multiplesFilter")[0].id;
    $("#" + multiples_input_id).on("click", function (e) {
      console.log("Got to filter id functional dropdown prop:");
      e.stopPropagation();
    });
  }

  updateTempIdsTempTitlesComboTree(functionsArr, functionsIdsArr) {
    // console.log("Current tempids::", tempids)
    console.log("Current functionsArr::", functionsArr);
    token_obj = { functions: functionsArr, function_ids: functionsIdsArr };
    updateStorageToken(token_obj, "functions_combo_tree");
    new Tokens().showTokensinUI();

    document.getElementById("comboBoxTree").placeholder = "Enter functions";
    document.getElementById("comboBoxTree").value = "";
  }
}

class VisitorFp {
  setupVisitorFP() {
    if (sessionStorage["visitor_fp"] == "") {
      const fpPromise = import("https://fpcdn.io/v3/GZ0fMHzCdTfnNEjX1f9p").then((FingerprintJS) =>
        FingerprintJS.load({
          apiKey: "GZ0fMHzCdTfnNEjX1f9p",
          endpoint: "https://metrics.arxena.com",
        })
      );

      // Get the visitor identifier when you need it.
      fpPromise
        .then((fp) => fp.get())
        .then((result) => {
          const visitorId = result.visitorId;
          sessionStorage["visitor_fp"] = visitorId;
          console.log(visitorId);

          Cookies.set("visitor_fp", sessionStorage["visitor_fp"], {
            expires: 7,
            path: "/",
          });
        });
      mixpanel.identify(sessionStorage["visitor_fp"]);
    }
  }
}

class LoadDataPeopleCompaniesOrgCharts {
  searchAutoCompleteDropDownClick(user_input) {
    console.log("user_input:::", user_input);
    // dropdown_class_name =
    sessionStorage["data_source"] = "arxena";

    addTokentoSessionStorage(user_input);
    document.getElementById("filters_autocomplete_dropdown_list_" + dropdown_class_name).innerHTML = "";
    // document.getElementById("input_enter_text_"+dropdown_class_name).innerHTML = "Enter "+dropdown_class_name
    document.getElementById("filters_autocomplete_dropdown_" + dropdown_class_name).value = "";
    document.getElementById("left_filter_input_id_" + dropdown_class_name).value = "";
    console.log("got here to show tokens in searchAutoCompleteDropDownClick");
    new Tokens().showTokensLoadResults("searchAutoCompleteDropDownClick");
    // after showing tokens; clear up the damn thing.
  }

  activityDescriptionTextClicked(user_input) {
    console.log(user_input);
    user_input_request_id = user_input.getAttribute("request_id");
    activity_objs_arr = JSON.parse(sessionStorage["activity"])["activity"];
    console.log(user_input_request_id);
    console.log("activityDescriptionTextClicked FUNCTION CALLED");
    for (var i = 0; i < activity_objs_arr.length; i++)
      if (activity_objs_arr[i]["request_id"] == user_input_request_id) {
        console.log("FOUND THE MATCHING QUREY ID");
        activity_selected_query_obj = activity_objs_arr[i]["query"];
        current_focus = activity_objs_arr[i]["current_focus"];
      }
    console.log("This is the query obj that has to be working");
    console.log(activity_selected_query_obj);
    $(activity_modal).modal("hide");
    sessionStorage["query"] = JSON.stringify(activity_selected_query_obj);
    if (current_focus == "orgcharts") {
      window.history.pushState(null, null, "/org-chart/");
    } else if (current_focus == "people") {
      window.history.pushState(null, null, "/people/");
    } else if (current_focus == "companies") {
      window.history.pushState(null, null, "/companies/");
    }
    new Pages().searchPage();
  }
  loadContactInfoAnyTypeContactInfo(response, type_contact_info = "") {
    let person_id = sessionStorage["person_id"];
    console.log("This is the load contact info");
    console.log(response);
    console.log(response["results"]["data"]["modified_query_results"]);
    var phone_numbers = response["results"]["data"]["modified_query_results"]["phone_numbers"];
    var emails = response["results"]["data"]["modified_query_results"]["emails"];
    console.log(phone_numbers);
    console.log(emails);
    console.log("Status is okay. This is data");
    console.log("type_contact_info::", type_contact_info);
    // email1 = 'arnavsaxena18@gmail.com'
    // email2 = 'arnav@panda.com'
    // phone = '+919969229131'
    console.log("got here to setupContactData");
    console.log("type_contact_info::", type_contact_info);
    new LoadDataPeopleCompaniesOrgCharts().loadContactInfoFromPhoneEmails(emails, phone_numbers, person_id, type_contact_info);

    // document.getElementById(type_contact_info+'whatsapp_link_'+person_id).innerHTML = '<img  onmouseout="new ManageContactsFetching().mouseOutWhatsapp(this)" whatsapp = '+phone+'  onclick= "new ManageContactsFetching().clickedSeeMoreWhatsappLink(this, '+phone+')" width="25" height="25" data-toggle="tooltip" data-html="true"  data-original-title="'+phone+'<br/>Click to Message" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABmJLR0QA/wD/AP+gvaeTAAAETUlEQVRIid2VXUxbZRzGn9NzTtvTL6BflFIZ5SOBQBzLYCSMRLIJN+5KY7xbsgvdojFGjTqT+ZE449ArXSIs4QIvzJKZmN1o/MiIyljiMAiyItBCoVBa2p4WWg5tz0dfL5CTsvIxvTI+Vyfv+zzv7///n5z3AP8XUUcZpvx+D0vrLnJa9izN0HaKojhCSFaWFT4vSiNCVrrR3lIf+lf0qUDAOR8Kfx1NJDN5USL7SZQkEk0kM/5Q+Pb09GLlP+pkOrDUZTFyX1U77G6a1mAtF8Vd/j4WhWWk5QzMjBFeQw26bZ3wcG4oSgHheCKSEXLPtjYcGzsSMh1Y6qqwmL6pdtjKk+IGBoLDuBMfBQHZp0IKPfYuvFR3ATatFZE4v5lMC089DNoDmfD7HTaTZbLG5XQvCsu4PHMV8Tx/yFB3ZNdaca3lCuqNtQhFY2sbQubE8YaG2O6+pths0nGDbofNnRQ38PbMh4jnedAUDT2tPxSSEJO47LsKXkyh2ml3c1pusHhfhUzOzVVbDIZehqYxEBxGLJ+ATqPDwPF+3O4chkNnOxI0EBwGrdHAYuCe/M23UFMC0Wn1z1dYTOZIbh134qMAgDOObjSa6qDTaHHO1XcoBABG4ncRzkVgLTObDRz7QglEy7K9WpbFWHJcfclWtlw9oM3SciSEgGCMHwfLMNBr2bMlEIZmrACwKCyroQeZWfV5aPnLIyHFeYamrSUQDUUZASAtZ9TA1KYP46lJAECzufGRILt5SkMZSiAERAQAI83tCfX7r4MXU7hYex499tPquoHm8BhXXQIpZy0AgEKBCCUQRZbXAaDB6N0T4sUU3vvzY2SVHN5teg2vN1yCS+/E+01v4IuTn+GD5rfg4dyqv85YuwNRZPUDUyF5SRmVZBndtk5QD10EvswcXn3wDsLZKM65+nCzfRAdFW2gQKHb1okua/vOiEDhtLUDoiQhJynfl0By4vb15GYmXaWvxBlHd8kY/FtBXJh4BZ8Hh7EgLKnrASGIH2O/AAB6nU+gSl+JVHork80LQ7uePSUvrKz9WuepOvVD7Gd8NP9pCahYDp0NZsaEoBACAYFTZ8eNtk9g0piwFI7eajzmeW7XyxQHWYapAoDfN6cPBQBAPM+r95pTZ8e1lisoZ8sQisRWk9uZF4u9KmRqJtBq5PSVBAQTG3+gydyIk2WPIy4mMBIfg0zkEhAFCn3OHlzynkc5W4ZwnE9t5YRnOpub+b2+vzUbXOmv87jepGkNtpUsTIxRNaWkDfyUuIeV7TUkRB4mxoQGYy26rB1w6Z2QFQXhGL+6lc0/3VpfM35g+4urkfuEEFIoFMjWdrYQifObS2vrc9FEMi1K+/8Z86JIIonk5vzS6k2fb8V60NnFnSxzeq0oSrJPlKRbooZ8e8Lr3ZiYnXVzOuPLOobuohnGSVMUpxCSlRWZl0T5u3RWGTrV4o0eWH2xfD6f9pGM/1X9Betv+WqCKZk0AAAAAElFTkSuQmCC">'
    // document.getElementById(type_contact_info+'email_link_'+person_id).innerHTML = '<img onmouseout="new ManageContactsFetching().mouseOutEmailLink(this)"  email = '+email1+' onclick= "new ManageContactsFetching().clickedSeeMoreEmailLink(this)" width="20" height="20" data-toggle="tooltip" data-html="true"  data-original-title="'+email1+'<br/>Click to copy"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACS0lEQVRIie3UP0iUYQDH8e/z3nlanouDOASJvRRxYNGdJdKgSWKEi1gOQoG46aJ3l7a9U6j3qkO6mYMUSKGLUViUDiLk/aGCI6jHMHBocqiz9Lx7n4Y4kfJOz3SJ+00PPD9+n+F5eSGXXP63iNShzL9Umqe0WQUVR2R9QEvUy4GqVQANoLw7UrcSuPjVkYzXolg6AvRNfjJ+WQ5UrZZ3R+q2YU2znuneYHN0uHrtuMi7Arw4RHSezUR9dLh6TfeFGzXNeroNAw6EmNT9wbb35rn1fOexRhBT/26qmYTz+zV5v+qb7g23gpoGCnbCADaUGNN9oe6o4YrLL8stKDF+YFPw6IQz1rRi1G7o/nAHQk0A9tS19lcdBnVfqI8nN5Ny8EI7MJQ1qtSoLHTfmjdqE7ov1INSI39af8Kp9Oje4AgGQpoeL9CbBdsvBys7MVC6P2QCfbuV0sEgRIe+Hp6oMebs0vT0I0QnYGUAFeCVpqeXG49tujcyhsKbrpwe/j3VuhpzTpcZcwUy4B4FcRtI7NJMIlS7ND1DLiPq0E+WTyJUW6bpzDAAotEeK3p+5s5CkTTdD0E0ARs7CnEhVIsMVI5X+N4VbsZ+zgDNe63uAwagJmkVvHR1LRZL0z2jENcRfAaWlUbDp0DllKtrsfgHW6+A+v0M2veubOfSps2xcLrr7dWP5vnXwKnURZl/qTSutFmy+N1mAwOctWyJiO4P3tUSebMAlm2rASXuKSjJZihbGKAEJR5YttQ3JjKW02W/b3zoycG55JLLgfMLj5fG3dWJEp4AAAAASUVORK5CYII=">'

    document.getElementById("loader_link_" + person_id).innerHTML = "";
    // $('[data-toggle="tooltip"]').tooltip({ placement : 'top'});
    new UtilityFunctions().activateToolTips();
    new Tokens().resetSessionStorageTokensForContactInfo();
  }

  loadCostCredits(cost_credits, count_db_results) {
    console.log("These are the cost credits::", cost_credits);
    console.log("Got here to load cost of credits HTML");
    if (sessionStorage["current_focus"] == "orgcharts") {
      document.getElementById("cost_of_credits_org_chart").innerHTML =
        'Estimated cost : <strong id="required_credits_node">' +
        cost_credits +
        " credits for " +
        count_db_results +
        ' people</strong> <i style="display:inline-block;color:rgb(197,197,205);" class="fa fa-info-circle " data-toggle="tooltip" data-original-title="Final Credits will slightly lower based on real time computation of number of profiles fetched"></i>';
      sessionStorage["count_cost_credits"] = cost_credits;
      sessionStorage["count_db_results"] = count_db_results;
      var element = document.getElementById("fetch_nodes_data_count");
      if (count_db_results < 100) {
        element.setAttribute("value", sessionStorage["count_db_results"]);
      } else {
        element.setAttribute("value", 100);
      }
      new UtilityFunctions().activateToolTips();
      new Selections().updateFetchNodesDataCount();
    } else if (sessionStorage["current_focus"] == "people") {
      document.getElementById("cost_of_credits_people").innerHTML = 'Estimated cost for this people report: <strong id="required_credits_node">' + cost_credits + " credits for " + count_db_results + " people</strong>";
      var element = document.getElementById("fetch_people_data_count");
      if (count_db_results < 100) {
        element.setAttribute("value", sessionStorage["count_db_results"]);
      } else {
        element.setAttribute("value", 100);
      }
      // element.setAttribute("value", sessionStorage['count_db_results']);
      new Selections().updateFetchPeopleDataCount();
    } else if (sessionStorage["current_focus"] == "companies") {
      // cost_credits = cost_credits.length
      document.getElementById("cost_of_credits_companies").innerHTML = 'Estimated cost for company report: <strong id="required_credits_node">' + cost_credits + " credits for " + count_db_results + " companies</strong>";
      var element = document.getElementById("fetch_companies_data_count");
      if (count_db_results < 100) {
        element.setAttribute("value", sessionStorage["count_db_results"]);
      } else {
        element.setAttribute("value", 100);
      }
      // element.setAttribute("value", sessionStorage['count_db_results']);
      new Selections().updateFetchCompaniesDataCount();
    }
  }

  // function loadFunctionsDropdown(){
  //     console.log("loadFunctionsDropdown FUNCTION CALLED with locations_db_results  as::");

  //     document.getElementById("select_functions_data_dropdown").style.display = ""

  //     // over writing locations DB results using locations from the session storage and giving it to locations functions. Actually needn't have called the query function at all because its being over written here.
  //     // locations = JSON.parse(sessionStorage['org_chart_data_countries'])
  //     // locations_db_results = []
  //     // for (var i = 0; i < locations.length; i++){
  //     //     locations_db_results.push({"location":locations[i]})
  //     // }
  //     all_functions_list=  functions_list
  //     functions_dropdown_rows = ''
  //     for (var i = 0; i <all_functions_list.length; i++){
  //         functions_dropdown_rows += '<a class="dropdown-item" onclick="selectFunctionsDropdownData(this)" functions_required="'+all_functions_list[i]+'" label="'+all_functions_list[i]+'">'+all_functions_list[i]+'</a>'
  //     }
  //     label = 'sales'
  //     // sessionStorage['functions_list_dropdown'] = label

  //     // functions_dropdown_button = document.getElementById("modal_functions_dropdown_button").innerHTML
  //     // .replace('{functions_dropdown_rows}',functions_dropdown_rows)
  //     // .replace('{count}', '1')
  //     // .replace('{functions_level}', '<br>')
  //     // .replace('{functions_search_text}',label)
  //     // document.getElementById("modal_functions_dropdown").innerHTML = functions_dropdown_button

  // }

  loadSubFunctionsDropdown() {
    console.log("loadSubFunctionsDropdown FUNCTION CALLED with locations_db_results  as::");
    document.getElementById("select_std_function_data_dropdown").style.display = "";
    // over writing locations DB results using locations from the session storage and giving it to locations functions. Actually needn't have called the query function at all because its being over written here.
    // locations = JSON.parse(sessionStorage['org_chart_data_countries'])
    // locations_db_results = []
    // for (var i = 0; i < locations.length; i++){
    //     locations_db_results.push({"location":locations[i]})
    // }
    var all_functions_list = functions_list;
    var functions_dropdown_rows = "";
    for (var i = 0; i < all_functions_list.length; i++) {
      functions_dropdown_rows +=
        '<a class="dropdown-item" style="cursor:pointer" onclick="selectSubFunctionsDropdownData(this)" functions_required="' + all_functions_list[i] + '" label="' + all_functions_list[i] + '">' + all_functions_list[i] + "</a>";
    }
    var label = "sales";
    // sessionStorage['functions_list_dropdown'] = label

    var functions_dropdown_button = document
      .getElementById("modal_sub_functions_dropdown_button")
      .innerHTML.replace("{std_functions_dropdown_rows}", functions_dropdown_rows)
      .replace("{count}", "1")
      .replace("{std_functions_level}", "<br>")
      .replace("{std_functions_search_text}", label);
    document.getElementById("modal_std_functions_dropdown").innerHTML = functions_dropdown_button;
  }

  loadGradesDropdown() {
    console.log("loadGradesDropdown FUNCTION CALLED with locations_db_results  as::");

    document.getElementById("select_grades_data_dropdown").style.display = "";

    var all_grades_list = ["leadership", "mid", "entry"];
    // all_functions_list=  functions_list
    var grades_dropdown_rows = "";
    for (var i = 0; i < all_grades_list.length; i++) {
      grades_dropdown_rows += '<a class="dropdown-item" style="cursor:pointer" onclick="selectGradesDropdownData(this)" grades="' + all_grades_list[i] + '" label="' + all_grades_list[i] + '">' + all_grades_list[i] + "</a>";
    }
    var label = "seniority";
    // sessionStorage['functions_list_dropdown'] = label

    var grades_dropdown_button = document
      .getElementById("modal_grades_dropdown_button")
      .innerHTML.replace("{grades_dropdown_rows}", grades_dropdown_rows)
      .replace("{count}", "1")
      .replace("{std_grades_level}", "<br>")
      .replace("{grades_search_text}", label);
    document.getElementById("modal_grades_dropdown").innerHTML = grades_dropdown_button;
  }

  loadFunctionsTreeDropdown() {
    console.log("loadFunctionsTreeDropdown FUNCTION CALLED with locations_db_results  as::");
    document.getElementById("select_functions_tree_data_dropdown").style.display = "";

    // over writing locations DB results using locations from the session storage and giving it to locations functions. Actually needn't have called the query function at all because its being over written here.
    // locations = JSON.parse(sessionStorage['org_chart_data_countries'])
    // locations_db_results = []
    // for (var i = 0; i < locations.length; i++){
    //     locations_db_results.push({"location":locations[i]})
    // }
    var functions_tree = [];
    if (document.getElementById("functions_tree").getAttribute("data-row") != "") {
      functions_tree = JSON.parse(document.getElementById("functions_tree").getAttribute("data-row"));
    }

    var menu_string = "";
    var submenu_string = [];

    var elem = functions_tree["tree_obj"].sort((a, b) => a.title.localeCompare(b.title));
    for (var i = 0; i < elem.length; i++) {
      var sub_elem_string = "";
      var submenu_string = "";
      if (typeof elem[i]["subs"] !== "undefined") {
        var sub_elem = elem[i]["subs"].sort((a, b) => a.title.localeCompare(b.title));
        for (var j = 0; j < sub_elem.length; j++) {
          sub_elem_string =
            sub_elem_string +
            '<li class="dropdown-item" style="padding-left: 0px; padding-right: 0px;cursor:pointer;"><a class="dropdown-item"  onclick="new Selections().selectFunctionsTreeFunctionsItem(this)"  style="cursor:pointer;" function_name = "' +
            sub_elem[j].title +
            '" >' +
            sub_elem[j]["title"] +
            "</a></li>";
        }
        submenu_string = submenu_string + '<ul class="dropdown-menu" style="font-size: inherit;max-height:30vh; overflow:scroll;cursor:pointer;">' + sub_elem_string + "</ul>";
      }

      menu_string =
        menu_string +
        '<li class="dropdown-submenu"><a class="dropdown-item" style="cursor:pointer;" onclick="selectFunctionsTreeFunctionsRootItem(this)" tabindex="-1" function_root= "' +
        elem[i].title +
        '" > ' +
        elem[i].title +
        " </a>" +
        submenu_string +
        "</li>";
    }

    var label = "functions";
    var functions_tree_dropdown_button = document
      .getElementById("modal_functions_tree_dropdown_button")
      .innerHTML.replace("{function_tree_dropdown_rows}", menu_string)
      .replace("{functions_tree_search_text}", label)
      .replace("{count}", "1")
      .replace("{std_grades_level}", "<br>")
      .replace("{grades_search_text}", label);
    document.getElementById("modal_functions_tree_dropdown").innerHTML = functions_tree_dropdown_button;
  }

  loadLocationsDropdown1(locations_db_results) {
    console.log("loadLocationsDropdown1 FUNCTION CALLED with locations_db_results  as::", locations_db_results);
    // over writing locations DB results using locations from the session storage and giving it to locations functions. Actually needn't have called the query function at all because its being over written here.
    // locations = JSON.parse(sessionStorage['org_chart_data_countries'])
    // locations_db_results = []
    // for (var i = 0; i < locations.length; i++){
    //     locations_db_results.push({"location":locations[i]})
    // }

    var location_dropdown_rows = "";
    for (var i = 0; i < locations_db_results.length; i++) {
      location_dropdown_rows +=
        '<a class="dropdown-item" style="cursor:pointer;" onclick="new Selections().selectLocationsFetchData1(this)" locations_required="' + locations_db_results[i] + '" label="' + locations_db_results[i] + '">' + locations_db_results[i] + "</a>";
    }
    var label = "global";
    sessionStorage["locations_dropdown1"] = label;

    var locations_dropdown_button = document
      .getElementById("modal_locations_dropdown_button")
      .innerHTML.replace("{locations_dropdown_rows}", location_dropdown_rows)
      .replace("{count}", "1")
      .replace("{location_level}", "<br>")
      .replace("{location_search_text}", label);
    document.getElementById("modal_locations_dropdown1").innerHTML = locations_dropdown_button;
  }

  loadLocationsDropdown2(locations_db_results) {
    console.log("loadLocationsDropdown2 FUNCTION CALLED with locations_db_results  as::", locations_db_results);
    var location_dropdown_rows = "";
    for (var i = 0; i < locations_db_results.length; i++) {
      location_dropdown_rows +=
        '<a class="dropdown-item" style="cursor:pointer;" onclick="new Selections().selectLocationsFetchData2(this)" locations_required="' + locations_db_results[i] + '" label="' + locations_db_results[i] + '">' + locations_db_results[i] + "</a>";
    }
    var locations_dropdown_button = document
      .getElementById("modal_locations_dropdown_button")
      .innerHTML.replace("{locations_dropdown_rows}", location_dropdown_rows)
      .replace("{count}", "2")
      .replace("{location_level}", "<br>")
      .replace("{location_search_text}", "Select Region");

    document.getElementById("modal_locations_dropdown2").innerHTML = locations_dropdown_button;
  }

  loadLocationsDropdown3(locations_db_results) {
    console.log("loadLocationsDropdown3 FUNCTION CALLED with locations_db_results  as::", locations_db_results);
    var location_dropdown_rows = "";
    for (var i = 0; i < locations_db_results.length; i++) {
      location_dropdown_rows +=
        '<a class="dropdown-item" style="cursor:pointer;" onclick="new Selections().selectLocationsFetchData3(this)" locations_required="' + locations_db_results[i] + '" label="' + locations_db_results[i] + '">' + locations_db_results[i] + "</a>";
    }
    var locations_dropdown_button = document
      .getElementById("modal_locations_dropdown_button")
      .innerHTML.replace("{locations_dropdown_rows}", location_dropdown_rows)
      .replace("{count}", "3")
      .replace("{location_search_text}", "Select Locality")
      .replace("{location_level}", "");

    document.getElementById("modal_locations_dropdown3").innerHTML = locations_dropdown_button;
  }

  loadModalfetchAllFunctionDataResults(key) {
    var node = myDiagram.findNodeForKey(key);
    var event_modal = {};
    var fetch_obj = {};
    fetch_obj._buttonID = "fetchNodeFunctionGradeDataResults";
    fetch_obj.part = node;
    fetchNodeContextMenuClickedResults(node, fetch_obj);
  }

  loadModalFetchOrgChartNodeData() {
    var key = JSON.parse(sessionStorage["orgchart_list_of_arrays"]).filter((x) => x["std_function"] == "ceo" && x["std_grade"] == "ceo")[0]["key"];
    var node = myDiagram.findNodeForKey(key);
    var event_modal = {};
    var fetch_obj = {};
    fetch_obj._buttonID = "fetchOrgChartFunctionGradeDataResults";
    // fetch_obj.part = node
    fetchNodeContextMenuClickedResults(node, fetch_obj);
  }

  loadContactInfoFromPhoneEmails(emails, phone_numbers, person_id, type_contact_info) {
    console.log("Got here to loadContactInfoFromPhoneEmails");
    try {
      var email1 = emails[0]["address"];
    } catch {
      var email1 = undefined;
    }
    try {
      var email2 = emails[1]["address"];
    } catch {
      var email2 = undefined;
    }
    try {
      var phone = phone_numbers[0];
    } catch {
      var phone = undefined;
    }
    // phone = phone_numbers[0]
    console.log("The email::", email1);
    console.log("The phone::", phone);
    console.log("The email 22::", email2);
    console.log("This is the typecontactinfo::", type_contact_info);
    if (phone != undefined) {
      try {
        var whatsappElem = document.getElementById(type_contact_info + "whatsapp_link_" + person_id);
        if (whatsappElem) {
          whatsappElem.innerHTML =
          '<img  onmouseout="new ManageContactsFetching().mouseOutWhatsapp(this)" whatsapp = ' +
          phone +
          '  onclick= "new ManageContactsFetching().clickedSeeMoreWhatsappLink(this, ' +
          phone +
          ')" width="25" height="25" data-toggle="tooltip" data-html="true"  data-original-title="' +
          phone +
          '<br/>Click to Message" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABmJLR0QA/wD/AP+gvaeTAAAETUlEQVRIid2VXUxbZRzGn9NzTtvTL6BflFIZ5SOBQBzLYCSMRLIJN+5KY7xbsgvdojFGjTqT+ZE449ArXSIs4QIvzJKZmN1o/MiIyljiMAiyItBCoVBa2p4WWg5tz0dfL5CTsvIxvTI+Vyfv+zzv7///n5z3AP8XUUcZpvx+D0vrLnJa9izN0HaKojhCSFaWFT4vSiNCVrrR3lIf+lf0qUDAOR8Kfx1NJDN5USL7SZQkEk0kM/5Q+Pb09GLlP+pkOrDUZTFyX1U77G6a1mAtF8Vd/j4WhWWk5QzMjBFeQw26bZ3wcG4oSgHheCKSEXLPtjYcGzsSMh1Y6qqwmL6pdtjKk+IGBoLDuBMfBQHZp0IKPfYuvFR3ATatFZE4v5lMC089DNoDmfD7HTaTZbLG5XQvCsu4PHMV8Tx/yFB3ZNdaca3lCuqNtQhFY2sbQubE8YaG2O6+pths0nGDbofNnRQ38PbMh4jnedAUDT2tPxSSEJO47LsKXkyh2ml3c1pusHhfhUzOzVVbDIZehqYxEBxGLJ+ATqPDwPF+3O4chkNnOxI0EBwGrdHAYuCe/M23UFMC0Wn1z1dYTOZIbh134qMAgDOObjSa6qDTaHHO1XcoBABG4ncRzkVgLTObDRz7QglEy7K9WpbFWHJcfclWtlw9oM3SciSEgGCMHwfLMNBr2bMlEIZmrACwKCyroQeZWfV5aPnLIyHFeYamrSUQDUUZASAtZ9TA1KYP46lJAECzufGRILt5SkMZSiAERAQAI83tCfX7r4MXU7hYex499tPquoHm8BhXXQIpZy0AgEKBCCUQRZbXAaDB6N0T4sUU3vvzY2SVHN5teg2vN1yCS+/E+01v4IuTn+GD5rfg4dyqv85YuwNRZPUDUyF5SRmVZBndtk5QD10EvswcXn3wDsLZKM65+nCzfRAdFW2gQKHb1okua/vOiEDhtLUDoiQhJynfl0By4vb15GYmXaWvxBlHd8kY/FtBXJh4BZ8Hh7EgLKnrASGIH2O/AAB6nU+gSl+JVHork80LQ7uePSUvrKz9WuepOvVD7Gd8NP9pCahYDp0NZsaEoBACAYFTZ8eNtk9g0piwFI7eajzmeW7XyxQHWYapAoDfN6cPBQBAPM+r95pTZ8e1lisoZ8sQisRWk9uZF4u9KmRqJtBq5PSVBAQTG3+gydyIk2WPIy4mMBIfg0zkEhAFCn3OHlzynkc5W4ZwnE9t5YRnOpub+b2+vzUbXOmv87jepGkNtpUsTIxRNaWkDfyUuIeV7TUkRB4mxoQGYy26rB1w6Z2QFQXhGL+6lc0/3VpfM35g+4urkfuEEFIoFMjWdrYQifObS2vrc9FEMi1K+/8Z86JIIonk5vzS6k2fb8V60NnFnSxzeq0oSrJPlKRbooZ8e8Lr3ZiYnXVzOuPLOobuohnGSVMUpxCSlRWZl0T5u3RWGTrV4o0eWH2xfD6f9pGM/1X9Betv+WqCKZk0AAAAAElFTkSuQmCC">';
        }
      } catch (error) {
        console.log("Error:", error);
      }
      try {
        var phoneElem = document.getElementById(type_contact_info + "phone_link_" + person_id);
        if (phoneElem) {
          phoneElem.innerHTML =
          '<img  onmouseout="new ManageContactsFetching().mouseOutPhoneLink(this)" phone = ' +
          phone +
          ' onclick= "new ManageContactsFetching().clickedSeeMorePhoneLink(this, ' +
          phone +
          ')" width="20" height="20" data-toggle="tooltip" data-html="true"  data-original-title="' +
          phone +
          '<br/>Click to copy"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABs0lEQVRIie2RP09TURjGf++hWAIkDIohbqSNi4DEXhLSpehYElhc+wEwxkHaGIgmjQ6QUFG+g58AAomDwQ5EoxdjE5XEXNRVSRzUodh77+tga27KhUK9mz7Tec55zvM7f+C/WkiCJpm3N4GJwNRPkKtOKbXWLsA0+XSTP4Vopt3yMMC35oD6nI4QoJ+aAyKMRAZQlTchmdEL1972RgIwRsohmdf9Z79UIwFoTNaBWmBqx6u52afFy24kAGfh0h6wUbe7dJrMx5Xxz+2WHwAA4MtifTQQU+n5m/JQgLOceq6wDvS4rvcwcgBAh6c3gB/AdDJv34oc8P7B2AeQmbpdSM6+zIXlJoqbsXNFu/sogBy1mCjY90S5DSjCvLNkNf6H5Nyrfmr+Y+AiUFGlIsJXfC07y2OrxwKASqKwfbcOAZFV9bzrEo9Vcf0nKMMhm/adktXVMKFPFLig7i5Zd0BywHdUp8SYd9T8Z4eUA8SDpgXgt5xS6pHxdBR0DegFEsfZBy2f6KASN1+kpcMUUCaBzvADWX96Twxo6PysfcYzmhXfZECHEAaBPpQt5751pd3ef1C/AK39gs9y4lofAAAAAElFTkSuQmCC">';
        }
      } catch (error) {
        console.log("Error:", error);
      }
    } else {
      try {
        var whatsappElemClear = document.getElementById(type_contact_info + "whatsapp_link_" + person_id);
        if (whatsappElemClear) {
          whatsappElemClear.innerHTML = "";
        }
      } catch (error) {
        console.log("Error:", error);
      }
      try {
        var phoneElemClear = document.getElementById(type_contact_info + "phone_link_" + person_id);
        if (phoneElemClear) {
          phoneElemClear.innerHTML = "";
        }
      } catch (error) {
        console.log("Error:", error);
      }
    }
    if (email1 != undefined) {
      try {
        var emailElem = document.getElementById(type_contact_info + "email_link_" + person_id);
        if (emailElem) {
          emailElem.innerHTML =
          '<img onmouseout="new ManageContactsFetching().mouseOutEmailLink(this)"  email = ' +
          email1 +
          ' onclick= "new ManageContactsFetching().clickedSeeMoreEmailLink(this)" width="20" height="20" data-toggle="tooltip" data-html="true"  data-original-title="' +
          email1 +
          '<br/>Click to copy"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACS0lEQVRIie3UP0iUYQDH8e/z3nlanouDOASJvRRxYNGdJdKgSWKEi1gOQoG46aJ3l7a9U6j3qkO6mYMUSKGLUViUDiLk/aGCI6jHMHBocqiz9Lx7n4Y4kfJOz3SJ+00PPD9+n+F5eSGXXP63iNShzL9Umqe0WQUVR2R9QEvUy4GqVQANoLw7UrcSuPjVkYzXolg6AvRNfjJ+WQ5UrZZ3R+q2YU2znuneYHN0uHrtuMi7Arw4RHSezUR9dLh6TfeFGzXNeroNAw6EmNT9wbb35rn1fOexRhBT/26qmYTz+zV5v+qb7g23gpoGCnbCADaUGNN9oe6o4YrLL8stKDF+YFPw6IQz1rRi1G7o/nAHQk0A9tS19lcdBnVfqI8nN5Ny8EI7MJQ1qtSoLHTfmjdqE7ov1INSI39af8Kp9Oje4AgGQpoeL9CbBdsvBys7MVC6P2QCfbuV0sEgRIe+Hp6oMebs0vT0I0QnYGUAFeCVpqeXG49tujcyhsKbrpwe/j3VuhpzTpcZcwUy4B4FcRtI7NJMIlS7ND1DLiPq0E+WTyJUW6bpzDAAotEeK3p+5s5CkTTdD0E0ARs7CnEhVIsMVI5X+N4VbsZ+zgDNe63uAwagJmkVvHR1LRZL0z2jENcRfAaWlUbDp0DllKtrsfgHW6+A+v0M2veubOfSps2xcLrr7dWP5vnXwKnURZl/qTSutFmy+N1mAwOctWyJiO4P3tUSebMAlm2rASXuKSjJZihbGKAEJR5YttQ3JjKW02W/b3zoycG55JLLgfMLj5fG3dWJEp4AAAAASUVORK5CYII=">';
        }
      } catch (error) {
        console.log("Error:", error);
      }
    } else {
      try {
        var emailElemClear = document.getElementById(type_contact_info + "email_link_" + person_id);
        if (emailElemClear) {
          emailElemClear.innerHTML = "";
        }
      } catch (error) {
        console.log("Error:", error);
      }
    }
  }

  loadContactInfoPeopleTab(response) {
    console.log(response);
    console.log(response["results"]["data"]["modified_query_results"]);

    try {
      email1 = emails[0]["address"];
    } catch {
      email1 = undefined;
    }
    try {
      email2 = emails[1]["address"];
    } catch {
      email2 = undefined;
    }
    try {
      phone = phone_numbers[0];
    } catch {
      phone = undefined;
    }
    // phone = phone_numbers[0]
    console.log(email1);
    console.log(email2);
    console.log(phone);

    phone_numbers = response["results"]["data"]["modified_query_results"]["phone_numbers"];
    emails = response["results"]["data"]["modified_query_results"]["emails"];
    console.log(phone_numbers);
    console.log(emails);
    console.log("Status is okay. This is data");
    // for (var i =0 ; i < phone_numbers.length; i++){

    // }
    selector.innerHTML = document
      .getElementById("contact_details_element_people_contact_card")
      .innerHTML.replace("{contact_email_row1}", phone_numbers[0] === undefined ? "" : phone_numbers[0])
      .replace("{contact_email_row2}", phone_numbers[1] === undefined ? "" : phone_numbers[1])
      .replace("{contact_phone_row1}", emails[0] === undefined ? "" : emails[0]["address"])
      .replace("{contact_phone_row2}", emails[1] === undefined ? "" : emails[1]["address"]);
    selector.removeAttribute("onclick");

    new Tokens().resetSessionStorageTokensForContactInfo();
  }

  loadResults(response) {
    console.log("Loading results in loadResults function called");
    // console.log("Response got in loadResults::data", data)
    console.log("Response got in loadResults::", response);
    if ((response["results"]["data"]["raw_string_query_input"] != "") & (response["results"]["data"]["results_source"] != "industry_category")) {
      if (typeof response["results"]["data"]["modified_query_results"]["gpt3_company_search"] == "object" || typeof response["results"]["data"]["gpt3_company_search"] == "object") {
      } else {
        console.log("response results data raw string query input:::", response["results"]["data"]["raw_string_query_input"]);
        sessionStorage["current_focus"] = response["results"]["data"]["focus_type"];
        if (response["results"]["data"]["focus_type"] == "people" || response["current_focus"] == "people") {
          new Toggle().switchViewToPeople();
        }
        if (response["results"]["data"]["focus_type"] == "companies" || response["current_focus"] == "companies") {
          new Toggle().switchViewToCompanies();
        }
        if (response["results"]["data"]["focus_type"] == "orgcharts" || response["current_focus"] == "orgcharts") {
          // adding load type is query here to avoid confusion with the load type in the switch view to org charts problem
          sessionStorage["load_type"] = "query";
          new Toggle().switchViewToOrgCharts();
        }
      }
    } else {
    }
    if (response["results"]["data"]["results_source"] == "industry_category") {
      console.log("Response got in loadResults::industry_category", response);
      new LeftPanelDropdownFilters().updateLeftPanelWithNewTokensforArxenaReversed(response);
      new Query().fetchQueryShowResults();
    }

    // if (response['results']['data']['gpt3_company_search'].length>0){
    if (typeof response["results"]["data"]["modified_query_results"]["gpt3_company_search"] == "object" || typeof response["results"]["data"]["gpt3_company_search"] == "object") {
      console.log("Did get here lets see");

      if (typeof response["results"]["data"]["gpt3_company_search"] == "object") {
        console.log("Got here to do something with gopt3 company search as well");

        new LeftPanelDropdownFilters().updateLeftPanelWithNewTokensforArxenaReversed(response);
        new Query().fetchQueryShowResults();
      }
    } else {
    }
    // blank_session_storage_obj = '{"raw_text":[],"company_name":[],"functions":[],"grades":[],"position":[],"year_founded":[],"country":[],"location":[],"linkedin_url":[],"gender":[],"job_title":[]}'
    if (typeof response != "undefined") {
      var data = response["results"]["data"]["modified_query_results"];
      var response_params = response["response_params"];
      console.log(response_params);
      var number_results = response["number_results"];
      var count_db_results = response["count_db_results"];

      if (typeof response["results"]["data"]["modified_query_results"]["results_source"] == "string") {
        if (response["results"]["data"]["modified_query_results"]["results_source"] == "arxena_reversed") {
          new LeftPanelDropdownFilters().updateLeftPanelWithNewTokensforArxenaReversed(response);
          new Query().fetchQueryShowResults();
        }
      }
    } else {
    }
    var data = response["results"]["data"]["modified_query_results"];

    if (typeof response["results"]["data"]["gpt3_company_search"] == "object" || typeof response["results"]["data"]["modified_query_results"]["results_source"] == "string") {
      // if (response['results']['data']['gpt3_company_search'].length>0){
      if (typeof response["results"]["data"]["gpt3_company_search"] == "object" || response["results"]["data"]["modified_query_results"]["results_source"] == "arxena_reversed") {
        console.log("Not loading right panel results. Instead just have loaded left panel");
      }
    } else {
      console.log("Going down the path of loading data from the response in either company people or companies tab");

      if (sessionStorage["current_focus"] == "people") {
        new LoadDataPeopleCompaniesOrgCharts().loadPeopleData(response);
      } else if (sessionStorage["current_focus"] == "companies") {
        new LoadDataPeopleCompaniesOrgCharts().loadCompanyData(response);
      } else if (sessionStorage["current_focus"] == "orgcharts") {
        new LoadDataPeopleCompaniesOrgCharts().loadOrgChartData(response);
        if (data["status"] == "blank") {
          $(blank_data_modal).modal("show");
          // count_profiles
          // document.getElementById("blank_data_modal").innerHTML.replace("{count_profiles}", company_employee_count)
        }
        // console.log("company_employee_count:::", company_employee_count)
        // Can use company employee count to show actual data
      }
    }
    new UtilityFunctions().activateToolTips();
    // $('[data-toggle="tooltip"]').tooltip({ placement : 'top'});
  }

  loadCountResultsinPeopleorCompanies(data, count_db_results) {
    console.log("Got to loadCountResultsinPeopleorCompanies");
    if (typeof count_db_results == "undefined") {
      count_db_results = 0;
    }
    console.log("This is the count db results;;", count_db_results);
    if (sessionStorage["current_focus"] == "people") {
      var people_filters_elem = document.getElementById("people_filters_headers_element").innerHTML;
      // sometimes the countdbresults has come to be undefined and cannot convert to locale string
      try {
        document.getElementById("filter_people_headers_replace_element").innerHTML = people_filters_elem.replace("{number_of_results}", count_db_results.toLocaleString());
      } catch (error) {
        console.log("Error:", error);
      }
      sessionStorage["count_db_results"] = count_db_results;
      console.log("Session Storge sample people data::", sessionStorage["sample_people_data"]);
      if (sessionStorage["sample_people_data"] == "false") {
        // Have to figure out when to put This is the count db results as data.length
        // count_db_results = data.length
        // count_db_results = data.length
        var people_filters_elem = document.getElementById("people_filters_headers_element").innerHTML;
        document.getElementById("filter_people_headers_replace_element").innerHTML = people_filters_elem.replace("{number_of_results}", count_db_results.toLocaleString());
        document.getElementById("fetch_results_people").setAttribute("onclick", "downloadPeopleResults()");
        document.getElementById("fetch_results_people").innerHTML = "Export to Excel";
        $(export_to_excel_modal).modal("show");
      }
      try {
        document.getElementById("fetch_data_live_profiles_message").innerHTML = "Fetch all " + count_db_results.toLocaleString() + " profiles by clicking on Get complete profiles";
      } catch (error) {
        console.log("Error:", error);
      }
    } else if (sessionStorage["current_focus"] == "companies") {
      var company_filters_elem = document.getElementById("filter_companies_headers_element").innerHTML;
      document.getElementById("filter_companies_headers_replace_element").innerHTML = company_filters_elem.replace("{number_of_results}", count_db_results.toLocaleString());
      sessionStorage["count_db_results"] = count_db_results;
      console.log("Session Storge sample people data::", sessionStorage["sample_company_data"]);
      if (sessionStorage["sample_company_data"] == "false") {
        count_db_results = data.length;
        var company_filters_elem = document.getElementById("filter_companies_headers_element").innerHTML;
        document.getElementById("filter_companies_headers_replace_element").innerHTML = company_filters_elem.replace("{number_of_results}", count_db_results.toLocaleString());
        document.getElementById("fetch_results_companies").setAttribute("onclick", "downloadCompanyResults()");
        document.getElementById("fetch_results_companies").innerHTML = "Export to Excel";
      }
    } else {
      console.log("Got to loadCountResultsinPeopleorCompanies but no current focus so yeah can't say!");
    }
  }

  loadPeopleData(response) {
    var data = response["results"]["data"]["modified_query_results"];
    var response_params = response["response_params"];
    console.log(response_params);
    var number_results = response["number_results"];
    var count_db_results = response["count_db_results"];

    console.log("loadPeopleData function Called");
    console.log(data);
    sessionStorage["people_data"] = JSON.stringify(data);
    var people_list = data;
    var rows = "";
    for (var i = 0; i < people_list.length; i++) {
      if (people_list[i].job_company_size == "None") {
        var job_company_size = "";
      } else {
        var job_company_size = people_list[i].job_company_size ? people_list[i].job_company_size + " employees" : "";
      }

      if (people_list[i].industry == "None") {
        var industry = "";
      } else {
        var industry = people_list[i].industry;
      }

      if (people_list[i].linkedin_url != undefined) {
        var person_linkedin_url = people_list[i].linkedin_url;
      } else if (people_list[i].std_linkedin_url != undefined) {
        var person_linkedin_url = people_list[i].std_linkedin_url.replace("https://", "");
      } else {
        var person_linkedin_url = "";
      }

      if (typeof people_list[i].id == "undefined") {
        people_list[i].id = i + 1;
      }

      rows =
        rows +
        document
          .getElementById("people_contact_card_element")
          .innerHTML.replaceAll(/{person_id}/g, people_list[i].id ? people_list[i].id : "")
          .replace(/{full_name}/g, people_list[i].full_name ? people_list[i].full_name : "")
          .replace(/{company_name}/g, people_list[i].job_company_name ? people_list[i].job_company_name : "")
          .replace(/{job_title}/g, people_list[i].job_title ? people_list[i].job_title : "")
          .replace(/{job_company_size}/g, job_company_size ? job_company_size : "")
          .replace(/{website}/g, people_list[i].job_company_website ? people_list[i].job_company_website : "")
          .replace(/{industry}/g, (typeof industry != "undefined") & (industry != "0") ? industry : "")
          .replace(/{location}/g, (typeof people_list[i].location_name != "undefined") & (people_list[i].location_name != "0") ? people_list[i].location_name : "")
          .replaceAll(/{linkedin_url}/g, person_linkedin_url ? person_linkedin_url : "")
          .replaceAll(/{facebook_url}/g, people_list[i].facebook_url ? people_list[i].facebook_url : "")
          .replaceAll(/{twitter_url}/g, people_list[i].twitter_url ? people_list[i].twitter_url : "");
    }
    document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("right_search_results_people_element").innerHTML;
    document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("right_search_results_people_element").innerHTML;
    // document.getElementById("filter_people_headers_replace_element").innerHTML = document.getElementById("people_filters_headers_element").innerHTML
    // .replace('{number_of_results}', count_db_results)
    // sessionStorage['count_db_results'] = count_db_results
    document.getElementById("people_contact_cards").innerHTML = rows;
    console.log("show people elements loaded");

    for (var i = 0; i < people_list.length; i++) {
      try {
        if (typeof people_list[i].id == "undefined") {
          people_list[i].id = i + 1;
        }

        if (typeof people_list[i].facebook_url == "undefined" || people_list[i].facebook_url == "None" || people_list[i].facebook_url == "" || people_list[i].facebook_url == "0") {
          document.getElementById("contact_card_facebook_link_" + people_list[i].id).innerHTML = "";
        }
        if (person_linkedin_url == undefined || person_linkedin_url == "None" || person_linkedin_url == "" || person_linkedin_url == "0") {
          document.getElementById("contact_card_linkedin_link_" + people_list[i].id).innerHTML = "";
        }
        if (typeof people_list[i].twitter_url == "undefined" || people_list[i].twitter_url == "None" || people_list[i].twitter_url == "" || people_list[i].twitter_url == "0") {
          document.getElementById("contact_card_twitter_link_" + people_list[i].id).innerHTML = "";
        }
        document.getElementById("contact_card_phone_link_" + people_list[i].id).innerHTML = "";
        document.getElementById("contact_card_whatsapp_link_" + people_list[i].id).innerHTML = "";
        document.getElementById("contact_card_email_link_" + people_list[i].id).innerHTML = "";
        document.getElementById("loader_link_" + people_list[i].id).innerHTML = "";
        // When there is an sample people data set being loaded, enable all clicks to go to fetchAllPeopleResults()
        if (sessionStorage["sample_people_data"] == "true") {
          console.log("sample_people_data is true::::", sessionStorage["sample_people_data"]);
          document.getElementById("image_contact_card_contact_link_" + people_list[i].id).setAttribute("onclick", "new LoadDataPeopleCompaniesOrgCharts().fetchAllPeopleResults()");
          document.getElementById("contact_phone_mail_" + people_list[i].id).setAttribute("onclick", "new LoadDataPeopleCompaniesOrgCharts().fetchAllPeopleResults()");
          document.getElementById("view_org_chart_button_person_id_" + people_list[i].id).setAttribute("onclick", "new LoadDataPeopleCompaniesOrgCharts().fetchAllPeopleResults()");
          document.getElementById("view_org_chart_button_person_id_" + people_list[i].id).innerHTML = "Preview";
        } else {
          console.log("sessionStorage['sample_people_data' iiis fallse!!", sessionStorage["sample_people_data"]);
          try {
            var phone_numbers = JSON.parse(people_list[i]["phone_numbers"].replaceAll("'", '"'));
          } catch {
            var phone_numbers = [];
          }
          try {
            var emails = JSON.parse(people_list[i]["emails"].replaceAll("'", '"'));
          } catch {
            var emails = [];
          }
          console.log("Emails::", emails);
          console.log("Phone numbers::::", phone_numbers);
          if (phone_numbers != [] || emails != []) {
            var type_contact_info = "contact_card_";
            console.log("NONe of emails or phome numbers are []'");
            new loadContactInfoFromPhoneEmails().loadContactInfoFromPhoneEmails(emails, phone_numbers, people_list[i].id, type_contact_info);
            if (sessionStorage["data_coverage"] == "include_phone_and_email") {
              document.getElementById("contact_card_contact_link_" + people_list[i].id).innerHTML = "";
            }
          } else {
            console.log("Not loading any data for anython");
          }
        }
      } catch (error) {
        console.log("Error:", error);
      }
    }

    console.log("Going to check the Type of response is undefined so load countresults in people or companies tab", response, typeof response);

    // Sometimes the count is being over written by the next data query counts. So wrong counts are being shown. The second resource source is put so that it does not over write
    if ((typeof response == "undefined") & (response["source"] != "arxena_es")) {
      console.log("Type of response is undefined so load countresults in people or companies tab");
      var count_db_results = data.length;
      this.loadCountResultsinPeopleorCompanies(data, count_db_results);
    }
    if ((typeof response.results.data.modified_query_results == "object") & (response.results.data.number_results > 0)) {
      console.log("Type of response is undefined so load countresults in people or companies tab");
      // count_db_results = response.results.data.modified_query_results.length
      var count_db_results = count_db_results;
      this.loadCountResultsinPeopleorCompanies(response.results.data.modified_query_results, count_db_results);
    }

    if (data["results_source"] == "arxena_reversed") {
      // Lets not do this. So are going to comment this out
      // loadCountResultsinPeopleorCompanies({},data['count_db_results'])
    }
    console.log("Have created the  PEOPLE DATA HAPPILY");
    // $('[data-toggle="tooltip"]').tooltip({
    //     placement : 'top'
    // });
    new UtilityFunctions().activateToolTips();
  }

  loadOrgChartData(response) {
    console.log("Got here to load org chart data::", response);
    // data = response['results']['data']['modified_query_results']
    var data = response["results"]["data"]["modified_query_results"];
    var response_params = response["response_params"];
    console.log(response_params);
    var number_results = response["number_results"];
    var count_db_results = response["count_db_results"];

    console.log("Got here to loadOrgChartData");
    console.log(data);

    // sessionStorage['org_chart_data'] = JSON.stringify(data)
    new DrawOrgCharts().setUpSessionStorageOrgChartVariables(data);
    // sessionStorage['org_chart_data_company_name'] = data['company_name']
    // sessionStorage['org_chart_data_company_id'] = data['company_id']
    // sessionStorage['org_chart_data_countries'] = data['countries']
    // sessionStorage['functions_analytics'] = data['functions_analytics']
    // sessionStorage['location_analytics'] = data['location_analytics']
    var org_data = data;
    // org_data['functions'] = Object.keys(data.functions_analytics)
    // org_data['functions'] = data.functions
    // org_data['locations'] = data.countries_charted
    // org_data['function'] = 'full_company'
    // org_data['feedback'] = ""
    console.log(data);
    // if (Object.keys(org_data).length>0){
    // debugger;
    new DrawOrgCharts().drawOrgchart(org_data);
    console.log(response_params);
    console.log("Starting to try to modify multiple nodes");
    // console.log("These are the response params", response_params)
    var response_nodes = response_params ? response_params["past_data"] : [];
    console.log("response_nodes is ::", response_nodes);
    if (response_nodes.length > 0) {
      //  One or two of these should work
      // processMultipleNodes(data, response_nodes, org_data)
      console.log("Response nodes is more than 0");
      processMultipleNodes(data, response_nodes, org_data);
    } else {
      // handleIncompleteResponse(response)

      console.log("No past data found for this org chart");
    }
    // $('[data-toggle="tooltip"]').tooltip({
    //     placement : 'top'
    // });
    // }
    new UtilityFunctions().activateToolTips();
  }

  loadCompanyData(response) {
    var data = response["results"]["data"]["modified_query_results"];
    var response_params = response["response_params"];
    console.log(response_params);
    var number_results = response["number_results"];
    var count_db_results = response["count_db_results"];
    data = response["results"]["data"]["modified_query_results"];

    console.log("Show companies results called");
    // createSearchRequest()
    // data = createSearchRequest()
    console.log(data);
    sessionStorage["company_data"] = JSON.stringify(data);
    // data['number_of_results'] = 550
    // data['page_number'] = 5
    // data['interval'] = 10
    // companies = [{'company':'amazon', 'website':'amazon.com', 'industry':'computers', 'location':'united states'},{'company':'apple', 'website':'apple.com', 'industry':'computers', 'location':'united states'},{'company':'google', 'website':'google.com', 'industry':'computers', 'location':'united states'},{'company':'humphrey', 'website':'humphrey.com', 'industry':'computers', 'location':'united states'}]
    var companies = data;
    var rows = "";

    for (var i = 0; i < companies.length; i++) {
      var location_value = (companies[i]["locality"] ? companies[i]["locality"] : "") + " " + (companies[i]["region"] ? companies[i]["region"] : "") + " " + (companies[i]["country"] ? companies[i]["country"] : "");
      // location_value = companies[i]['locality'] & companies[i]['region'] & companies[i]['country']  ? companies[i]['locality']  + ', '+ (companies[i]['region']  + ', ' + (companies[i]['country']))

      rows =
        rows +
        document
          .getElementById("companies_cards_element")
          .innerHTML.replace(/{company_name}/g, companies[i].name || "")
          .replace(/{website}/g, companies[i].website ? "https://" + companies[i].website : "")
          .replace(/{industry}/g, companies[i].industry || "")

          .replace(/{location}/g, location_value || "")
          // .replace(/{region}/g, companies[i].region || "")
          // .replace(/{locality}/g, companies[i].locality || "")
          .replaceAll(/{company_id}/g, companies[i].id || "")
          .replace(/{linkedin_url}/g, companies[i].linkedin_url ? "https://" + companies[i].linkedin_url.replaceAll("'", "") : "")
          .replace(/{facebook_url}/g, companies[i].facebook_url ? "https://" + companies[i].facebook_url : "")
          .replace(/{twitter_url}/g, companies[i].twitter_url ? "https://" + companies[i].twitter_url : "")
          .replace(/{company_size}/g, companies[i].size || "");
    }

    document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("right_search_results_companies_element").innerHTML;
    document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("right_search_results_companies_element").innerHTML;
    // .replace('{number_of_results}', data['number_of_results'] )
    // .replace('{page_number}', data['page_number'] )
    // .replace('{interval}', data['interval'] )
    // document.getElementById("filter_companies_headers_replace_element").innerHTML = document.getElementById("filter_companies_headers_element").innerHTML
    // .replace('{number_of_results}',count_db_results)
    // sessionStorage['count_db_results'] = count_db_results
    document.getElementById("companies_cards").innerHTML = rows;

    for (var i = 0; i < companies.length; i++) {
      // console.log("ELEMENT::", rows)
      if (companies[i].linkedin_url == undefined) {
        var linkedin_element_id = "company_social_card_linkedin_" + companies[i].id;
        document.getElementById(linkedin_element_id).innerHTML = "";
      }

      if (companies[i].facebook_url == undefined) {
        var facebook_element_id = "company_social_card_facebook_" + companies[i].id;
        document.getElementById(facebook_element_id).innerHTML = "";
      }

      if (companies[i].facebook == undefined) {
        var twitter_element_id = "company_social_card_twitter_" + companies[i].id;
        document.getElementById(twitter_element_id).innerHTML = "";
      }
      if (companies[i].industry == undefined) {
        var industry_element_id = "company_details_field_industry_" + companies[i].id;
        document.getElementById(industry_element_id).innerHTML = "";
      }
      if (companies[i].size == undefined) {
        var size_element_id = "company_details_field_size_" + companies[i].id;
        document.getElementById(size_element_id).innerHTML = "";
      }
      if (companies[i].country == undefined) {
        var country_element_id = "company_details_field_location_" + companies[i].id;
        document.getElementById(country_element_id).innerHTML = "";
      }
    }
    if (typeof response == "undefined") {
      var count_db_results = data.length;
      this.loadCountResultsinPeopleorCompanies(data, count_db_results);
    }

    // $('[data-toggle="tooltip"]').tooltip({
    //     placement : 'top'
    //     });
    new UtilityFunctions().activateToolTips();
  }

  searchAllPeople() {
    console.log("searchAllPeople FUNCTION CALLED");
    $(search_all_people).modal("show");
    // sessionStorage['functional_area_selection_made'] = 'no'
  }

  fetchAllCompanyResults() {
    console.log("fetchAllCompanyResults FUNCTION CALLED");
    var element = document.getElementById("fetch_companies_data_count");
    var credits_to_be_used = new LoadDataPeopleCompaniesOrgCharts().computeCredits();
    element.setAttribute("value", sessionStorage["count_db_results"]);
    // console.log(document.getElementById('required_credits').innerHTML);
    console.log(credits_to_be_used);
    try {
      document.getElementById("dataCoverageRadio1_companies").checked = true;
      document.getElementById("dataSourceRadio1_companies").checked = true;
    } catch (error) {
      console.log("Error:", error);
    }
    sessionStorage["data_source"] = "data_broker_1";
    $(fetch_company_results).modal("show");
    new Query().fetchQueryShowResults("cost_credits");
  }

  computeCredits() {
    credits_to_be_used = 500;
    return credits_to_be_used;
  }
  fetchAllPeopleResults() {
    console.log("fetchAllPeopleResults FUNCTION CALLED");
    var element = document.getElementById("fetch_people_data_count");
    var credits_to_be_used = new LoadDataPeopleCompaniesOrgCharts().computeCredits();
    element.setAttribute("value", sessionStorage["count_db_results"]);
    // console.log(document.getElementById('required_credits').innerHTML);
    console.log(credits_to_be_used);
    // document.getElementById('required_credits_people').innerHTML = credits_to_be_used + " credits"
    // document.getElementById('required_credits').innerHTML
    // .replace("{number_of_credits}", "500")
    try {
      document.getElementById("dataCoverageRadio1_people").checked = true;
      document.getElementById("dataSourceRadio1_people").checked = true;
    } catch (error) {
      console.log("Error:", error);
    }
    $(fetch_people_results).modal("show");
    new Query().fetchQueryShowResults("cost_credits");
    // sessionStorage['functional_area_selection_made'] = 'no'
  }

  confirmFetchAllPeopleResults() {
    // Setting data source as data_broker_1 for all people queries where fetch data is necessary
    // sessionStorage['data_source'] = 'data_broker_1'
    console.log("This is the data source::", sessionStorage["data_source"]);
    if (sessionStorage["data_source"] == "arxena") {
      sessionStorage["data_source"] = "data_broker_1";
    }
    if (sessionStorage["data_source"] == "arxena") {
      console.log("Not letting go!");
      document.getElementById("pick_function_error_people").innerHTML = '<span style="color:red;text-align:center">Please fill in all requirements</span>';
    } else {
      console.log("Data Source::", sessionStorage["data_source"]);
      $(fetch_people_results).modal("hide");
      sessionStorage["consume_credits"] = "true";
      // sessionStorage['data_source'] = 'data_broker_1'
      new Query().fetchQueryShowResults("fetch_people_results_consume_credits");
      console.log("Data Source::", sessionStorage["data_source"]);
      sessionStorage["consume_credits"] = "false";
      sessionStorage["data_source"] = "arxena";
      console.log("fetch all rescults confirmed");
    }
  }

  confirmFetchAllCompanyResults() {
    if (sessionStorage["data_source"] == "arxena") {
      console.log("Not letting go!");
      document.getElementById("pick_function_error_people").innerHTML = '<span style="color:red;text-align:center">Please fill in all requirements</span>';
    } else {
      $(fetch_company_results).modal("hide");
      sessionStorage["consume_credits"] = "true";
      new Query().fetchQueryShowResults();
      sessionStorage["consume_credits"] = "false";
      sessionStorage["fetch_people_data_count"] = 0;
      console.log("fetch all rescults confirmed");
    }
  }

  cancelFetchAllPeopleResults() {
    $(fetch_people_results).modal("hide");
    sessionStorage["data_source"] = "arxena";
  }

  cancelFetchAllCompanyResults() {
    $(fetch_company_results).modal("hide");
    sessionStorage["data_source"] = "arxena";
  }
}


export { ComboTreeBox, VisitorFp, LoadDataPeopleCompaniesOrgCharts };
if (typeof window !== 'undefined') {
  window.ComboTreeBox = ComboTreeBox;
  window.VisitorFp = VisitorFp;
  window.LoadDataPeopleCompaniesOrgCharts = LoadDataPeopleCompaniesOrgCharts;
}
